import GetRequest from "../utilities/api/get-request";
import PostRequest from "../utilities/api/post-request";

class Subscription {

    /*
    |--------------------------------------------------------------------------
    | Settings
    |--------------------------------------------------------------------------
    |
    */

    static async getSettings() {
        const path = '/api/subscription/settings';

        return await GetRequest(path);
    }

    /*
    |--------------------------------------------------------------------------
    | Get checkout url
    |--------------------------------------------------------------------------
    |
    */

    static async getCheckoutUrl(data) {
        const path = '/api/subscription/checkout-url';

        return await GetRequest(path, data);
    }

    /*
    |--------------------------------------------------------------------------
    | Start trial
    |--------------------------------------------------------------------------
    |
    */

    static async startTrial(data) {
        const path = '/api/subscription/start-trial';

        return await PostRequest(path, data);
    }
}

export default Subscription;